<template>
<el-container>
  <el-main>
    <!-- 选择发卡设备 -->
    <el-dialog
      :title="$t('fingerprintList.chooseFingerprint')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="deviceVisible"
      width="600px"
      style="margin-top: -50px"
    >
        <el-table
        ref="tenantList"
        :data="devicePageData.deviceData"
        highlight-current-row
        @current-change="handleCurrentChangeDetailDevice"
        height="280px"
        style="margin-top: -10px"
      >
         <el-table-column
           prop="deviceName"
           :label="$t('fingerprintList.deviceName')"
           width="180">
         </el-table-column>

         <el-table-column
          prop="deviceType"
          :label="$t('fingerprintList.deviceType')"
          width="180">
         </el-table-column>

        <el-table-column
          prop="isOnline"
          :label="$t('fingerprintList.online')">
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px">
        <Pagings
          :total="devicePageData.total"
          :offset="devicePageData.offset"
          :pageSize="devicePageData.pageNumber"
          @handleSizeChangeSub="deviceHandleSizeChange"
          @handleCurrentChangeSub="deviceHandleCurrentChange"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseDevice">{{
          $t("apartmentRoomDetail.confirmChoose")
        }}</el-button>
        <el-button
          type="primary"
          @click="
            deviceVisible = false;
          "
          >{{ $t("apartmentRoomDetail.cancel") }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 选择租客 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.chooseTenant')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="tenantListVisible"
      width="600px"
      style="margin-top: -50px"
    >
    <el-form ref="form" label-width="80px">
      <el-form-item
        :label="$t('apartmentRoomDetail.tenantName')"
        style="margin-top: -15px"
      >
        <el-input v-model="selectForm.tenantName" style="width:200px" placeholder=""></el-input>
        <el-button type="primary" @click="onSelectTenant">{{
          $t("apartmentRoomDetail.qurey")
        }}</el-button>
      </el-form-item>
      
      <el-table
        ref="tenantList"
        :data="tenantPageData.tenantList"
        highlight-current-row
        @current-change="handleCurrentChangeDetail"
        height="280px"
        style="margin-top: -10px"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="tenantName"
          :label="$t('apartmentRoomDetail.tenantName')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantPhone"
          :label="$t('apartmentRoomDetail.tenantPhone')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantEmail"
          :label="$t('apartmentRoomDetail.tenantEmail')"
        ></el-table-column>
      </el-table>

      <div style="margin-top: 10px">
        <Pagings
          :total="tenantPageData.total"
          :offset="tenantPageData.offset"
          :pageSize="tenantPageData.pageNumber"
          @handleSizeChangeSub="tenantHandleSizeChange"
          @handleCurrentChangeSub="tenantHandleCurrentChange"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseTenant">{{
          $t("apartmentRoomDetail.confirmChoose")
        }}</el-button>
        <el-button
          type="primary"
          @click="
            tenantListVisible = false;
            checkInVisible = true;
          "
          >{{ $t("apartmentRoomDetail.cancel") }}</el-button
        >
      </div>
    </el-form> 
    </el-dialog>

    <el-dialog
      :title="$t('fingerprintList.fingerprintType')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="chooseFingerprintFlag"
      width="500px"
    >
     <el-form ref="form" label-width="100px">
      <el-form-item :label="$t('fingerprintList.leftHand')">
       <el-row>
        <el-radio v-model="addFgDevice.fingerType" label="1" size="medium" border>{{$t('fingerprintList.thumb')}}</el-radio>
        <el-radio v-model="addFgDevice.fingerType" label="2" size="medium" border>{{$t('fingerprintList.indexFinger')}}</el-radio>
        <el-radio v-model="addFgDevice.fingerType" label="3" size="medium" border>{{$t('fingerprintList.middleFinger')}}</el-radio>
       </el-row>
       <el-row>
        <el-radio v-model="addFgDevice.fingerType" label="4" border>{{$t('fingerprintList.ringFinger')}}</el-radio>
        <el-radio v-model="addFgDevice.fingerType" label="5" border>{{$t('fingerprintList.pinkie')}}</el-radio>
       </el-row> 

      </el-form-item>
       <el-form-item :label="$t('fingerprintList.rightHand')">
        <el-row>
        <el-radio v-model="addFgDevice.fingerType" label="6" size="medium" border>{{$t('fingerprintList.thumb')}}</el-radio>
        <el-radio v-model="addFgDevice.fingerType" label="7" size="medium" border>{{$t('fingerprintList.indexFinger')}}</el-radio>
        <el-radio v-model="addFgDevice.fingerType" label="8" size="medium" border>{{$t('fingerprintList.middleFinger')}}</el-radio>
        </el-row>
        <el-row>
        <el-radio v-model="addFgDevice.fingerType" label="9" size="medium" border>{{$t('fingerprintList.ringFinger')}}</el-radio>
        <el-radio v-model="addFgDevice.fingerType" label="10" size="medium" border>{{$t('fingerprintList.pinkie')}}</el-radio>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="confirmChooseFingerprint">{{$t('tenant.confirmChoose')}}</el-button>
        <el-button type="primary" @click="chooseFingerprintFlag = false;">{{$t('tenant.cancel')}}</el-button>
      </el-form-item>
     </el-form>
    </el-dialog>
   <el-dialog
      :title="$t('fingerprintList.addFinger')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addFgDeviceFlag"
      width="500px"
    >
      <el-form
        :inline="true"
        :model="addFgDevice"
        ref="addDevice"
        class="demo-ruleForm"
      >
      <el-form-item
        :label="$t('fingerprintList.collectorType')"
        label-width="120px"
      >
          <el-select
              v-model="addFgDevice.collectorType"
              style="width:200px"
              :placeholder="$t('fingerprintList.chooseCollectorType')"
            >
              <el-option
                v-for="item in addFgDevice.collectorData"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              ></el-option>
            </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('fingerprintList.fingerType')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="addFgDevice.fingerTypeLable"
            :placeholder="$t('fingerprintList.selectFinger')"
            style="width: 200px"
            disabled
            show-word-limit
          ></el-input>
           <el-button size="medium" icon="el-icon-thumb" type="primary" @click="chooseFingerType"></el-button>
      </el-form-item>
     
       <el-form-item
          :label="$t('fingerprintList.collector')"
          label-width="120px"
          v-show="addFgDevice.collectorType==0"
        >
          <el-input
            type="text"
            disabled
            v-model="addFgDevice.deviceName"
            :placeholder="$t('fingerprintList.chooseFingerCollector')"
            style="width: 200px"
            show-word-limit
          ></el-input>
          <el-button size="medium" :title="$t('fingerprintList.choose')" icon="el-icon-cpu" type="primary" @click="chooseDevice"></el-button>
      </el-form-item>
      
      <el-form-item
          :label="$t('fingerprintList.fingerId')"
          label-width="120px"
        >
          <el-input
            type="text"
            disabled
            v-model="addFgDevice.fingerprintId"
            :placeholder="$t('fingerprintList.fingerId')"
            style="width: 200px"
            show-word-limit
          ></el-input>
          <el-button size="medium" :title="$t('fingerprintList.collect')" icon="el-icon-key" type="primary" @click="collectFingerprint"></el-button>
      </el-form-item>

      <!-- <el-form-item
          label="指纹名称"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="addFgDevice.fingerprintName"
            placeholder="设备名称"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
      </el-form-item> -->
      
      <el-form-item
          :label="$t('fingerprintList.tenant')"
          label-width="120px"
        >
          <el-input
            type="text"
            disabled
            v-model="addFgDevice.tenantName"
            :placeholder="$t('fingerprintList.tenantName')"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
          <el-button size="medium" title="" icon="el-icon-user" type="primary" @click="chooseTenant"></el-button>
      </el-form-item>

       <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="confirmFingerprint">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="addFgDeviceFlag = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
    </el-form>  
  </el-dialog>
  <el-form :inline="true" class="demo-form-inline">
      <el-form-item :label="$t('fingerprintList.tenantName')">
         <el-input v-model="selectFingerprintForm.tenantName" prefix-icon="el-icon-search" :placeholder="$t('fingerprintList.inputTenantName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('fingerprintList.idCard')">
         <el-input v-model="selectFingerprintForm.tenantIdentityId" prefix-icon="el-icon-search" :placeholder="$t('fingerprintList.inputIdCard')"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" icon="el-icon-search" @click="onSelectFingerprint">{{$t('fingerprintList.search')}}</el-button>
        <el-button type="primary" plain icon="el-icon-operate" prefix-icon="el-icon-plus" @click="addFingerprint">{{$t('fingerprintList.collectFingerprint')}}</el-button>
      </el-form-item>
  </el-form>
 
  <el-table
    :data="pageData.fgData"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    empty-text="No Data"
    border
    style="margin-top: 5px"
   >
     <el-table-column
    prop="fingerType"
    :label="$t('fingerprintList.fingerprintType')"
    width="180">
      <template slot-scope="scope">
             {{scope.row.fingerType==0?$t('fingerprintList.undefined'):scope.row.fingerType==1?$t('fingerprintList.leftThumb'):scope.row.fingerType==2?$t('fingerprintList.leftIndexFinger'):scope.row.fingerType==3?$t('fingerprintList.leftHandMiddleFinger'):scope.row.fingerType==4?$t('fingerprintList.ringFingerOfLeftHand'):scope.row.fingerType==5?$t('fingerprintList.leftTailToRefer'):
             scope.row.fingerType==6?$t('fingerprintList.rightThumb'):scope.row.fingerType==7?$t('fingerprintList.rightIndexFinger'):scope.row.fingerType==8?$t('fingerprintList.rightHandMiddleFinger'):scope.row.fingerType==9?$t('fingerprintList.ringFingerOfRightHand'):scope.row.fingerType==10?$t('fingerprintList.rightTailToRefer'):""}}
      </template>  
    </el-table-column>

    <!-- <el-table-column
    prop="fingerprintName"
    label="指纹呢称"
    width="180">
    </el-table-column> -->

    <!-- <el-table-column
    prop="infoId"
    label="指纹ID">
    </el-table-column> -->

    <el-table-column
    prop="status"
    :label="$t('fingerprintList.status')">
     <template slot-scope="scope">
             {{scope.row.status==0?$t('fingerprintList.freeze'):scope.row.status==1?$t('fingerprintList.normal'):$t('fingerprintList.delete')}}
      </template>  
    </el-table-column>
     
    <el-table-column
    prop="tenantName"
    :label="$t('fingerprintList.tenantName')">
    </el-table-column>

    <el-table-column
    prop="tenantPhone"
    :label="$t('fingerprintList.tenantPhone')">
    </el-table-column>

    <el-table-column
    prop="tenantIdentityId"
    :label="$t('fingerprintList.tenantIdCard')">
    </el-table-column>
        
    <el-table-column
      prop
      :label="$t('apartmentRoomDetail.operate')"
      width="100"
      align="center"
    >
      <template slot-scope="scope">
        <el-button
          type="danger"
          size="mini"
          icon="el-icon-delete"
          :title="$t('fingerprintList.delete')"
          @click="handleEdit(scope.$index, scope.row)"
        ></el-button>
      </template>
    </el-table-column>
     
    </el-table>

    <el-footer>
      <div>
        <Pagings
        :total="pageData.total"
        :offset="pageData.offset"
        :pageSize="pageData.pageNumber"
        @handleSizeChangeSub="fHandleSizeChange"
        @handleCurrentChangeSub="fHandleCurrentChange">
        </Pagings>
      </div>
    </el-footer> 
  </el-main>
</el-container>      
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "fingerprintList",
  data() {
     return {
        pageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         fgData: [],
        },
        addFgDevice:{
           fingerType:'1',
           fingerTypeLable:"",
           deviceId:"",
           deviceName:"",
           fingerprintId:"",
           fingerprintName:"",
           tenantId:"",
           tenantName:"",
           collectorType:0,
           collectorData:[  
           {lable:this.$t('fingerprintList.networkCollector'),value:0},
           {lable:this.$t('fingerprintList.usbCollector'),value:1}
           ]
        },
        addFgDeviceFlag:false,
        chooseFingerprintFlag:false,
        tenantListVisible:false,
        deviceVisible:false,
        selectForm:{
          tenantName:""
        },
        tenantPageData:{
          offset: 1,
          pageNumber: 10,
          total: 0, //总条数
          tenantList:[]
        },
        currentTenantRow:"",
        devicePageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         deviceData: [],
        },
        currentDeviceRow:"",
        selectFingerprintForm:{
           tenantName:"",
           tenantIdentityId:""
        }
     }      
  },
  components: {
    Pagings
  },
  mounted() {
    this.tenantPower();
    this.devicePower();
    this.getFgPageList();
  },  
  methods: {
    //查询指纹
    onSelectFingerprint(){
      this.getFgPageList();
    },
    //编辑
    handleEdit(index, row) {
       this.$confirm(this.$t('fingerprintList.confirmDeleteFinger'),this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
          var formData = new FormData();
          formData.append("infoId",row.infoId);
          this.$server
           .exam("/customer/fingerprint/deleteFingerprint", formData)
           .then(data => {
             if (data.code == 200) {
               this.getFgPageList();
             } else {
               this.$message({
                message: data.message,
                type: "warning"
               });
             }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("tenant.cancelDelete")
          });          
        });  
       
    },
    //确定提交指纹
    confirmFingerprint(){
        var formData = new FormData();
        formData.append("acquisitionMode", this.addFgDevice.collectorType);
        formData.append("fingerType", this.addFgDevice.fingerType);
        formData.append("fingerprintId ", this.addFgDevice.fingerprintId);
        formData.append("associatedUserId", this.addFgDevice.tenantId);
        formData.append("userType",0);
        this.$server
          .exam("/customer/fingerprint/addFingerprint", formData)
          .then(data => {
           if (data.code == 200) {
               this.addFgDeviceFlag=false;
               this.getFgPageList();
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              }); 
            }
        });
    },
    //确定选择设备
    confirmChooseDevice(){
      // alert(this.currentDeviceRow.deviceName);
       this.deviceVisible=false;
       this.addFgDevice.deviceId=this.currentDeviceRow.deviceId;
       this.addFgDevice.deviceName=this.currentDeviceRow.deviceName;
    },
    //或者选择设备行记录
    handleCurrentChangeDetailDevice(val){
         this.currentDeviceRow=val;
    },
    //选择设备
    chooseDevice(){
      this.deviceVisible=true;
    },
    //采集指纹
    collectFingerprint(){
          var collectorType=this.addFgDevice.collectorType;
          if(this.addFgDevice.fingerType==""||this.addFgDevice.fingerType==null){
           this.$message({
            message: this.$t('tenant.chooseFingerType'),
            type: "warning"
           });
           return false;
         }
          if(collectorType==0){
             var formData = new FormData();
             if(this.addFgDevice.deviceId==""||this.addFgDevice.deviceId==null){
               this.$message({
                message: this.$t('fingerprintList.chooseFingerCollector'),
                type: "warning"
               });
               return false;
              }
            formData.append("deviceId", this.addFgDevice.deviceId);
            this.$server
            .exam("/customer/gateway/collectUserFingerprint", formData)
            .then(data => {
             if (data.code == 200) {
              var rtnData = data["data"];
              const loading = this.$loading({
                lock: true,
                text: this.$t('fingerprintList.binding'),
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
               });
              var obj = {};
               obj.rId = rtnData;
               obj.loading = loading;
               obj.othis=this;
               obj.opType = "collectUserFingerprint";
               this.$store.dispatch("checkResult", obj); //等待回调 
             } else {
                this.$message({
                 message: data.message,
                 type: "warning"
                });
              }
           });
         }else{
            var rtnData = JSON.parse(callbackObj.readFingerWeb());
						if(rtnData['code'] == 200) {
						  this.addFgDevice.fingerprintId=rtnData.data;
              this.$message({
               message:"采集成功",
               type: "success",
              });
						} else {
						  this.$message({
               message:rtnData['message'],
               type: "warning",
              });
						}
         }
    },
    //确认选择租客
    confirmChooseTenant() {
      if (this.currentTenantRow == "" || this.currentTenantRow == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.chooseTenant1"),
          type: "warning",
        });
        return false;
      }
      this.tenantListVisible = false;
      this.addFgDevice.tenantName = this.currentTenantRow.tenantName;
      this.addFgDevice.tenantId = this.currentTenantRow.tenantId;
    },
    //选择租客row
    handleCurrentChangeDetail(val) {
      this.currentTenantRow = val;
    },
    //查询租客
    onSelectTenant(){
      this.tenantPower();
    },
    //选择租客信息
    chooseTenant(){
      this.tenantListVisible=true;
    },
    //确定选择手指类型
    confirmChooseFingerprint(){
        this.chooseFingerprintFlag=false;
         switch(this.addFgDevice.fingerType){
            case "1":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.leftThumb");
              break;
            case "2":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.leftIndexFinger");
              break;
            case "3":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.leftHandMiddleFinger");
              break;
            case "4":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.ringFingerOfLeftHand");
              break;
            case "5":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.leftTailToRefer");
              break;
            case "6":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.rightThumb");
              break;
            case "7":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.rightIndexFinger");
              break;
            case "8":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.rightHandMiddleFinger");
              break;
            case "9":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.ringFingerOfRightHand");
              break;
            case "10":
              this.addFgDevice.fingerTypeLable=this.$t("tenant.rightTailToRefer");
              break;        
         }
      },
      chooseFingerType(){
        this.chooseFingerprintFlag=true;
      },
      addFingerprint(){
        //初始化页面参数和打开页面
         this.addFgDevice.fingerType="1";
         this.addFgDevice.fingerTypeLable="";
         this.addFgDevice.deviceId="";
         this.addFgDevice.deviceName="";
         this.addFgDevice.fingerprintId="";
         this.addFgDevice.tenantId="";
         this.addFgDevice.tenantName="";
         this.addFgDeviceFlag=true;
      },
      getFgPageList(){
          var formData = new FormData();
          if (this.selectFingerprintForm.tenantName != "" &&this.selectFingerprintForm.tenantName != null) {
             formData.append("userName", this.selectFingerprintForm.tenantName);
          }
          if (this.selectFingerprintForm.tenantIdentityId != "" &&this.selectFingerprintForm.tenantIdentityId != null) {
             formData.append("identityId", this.selectFingerprintForm.tenantIdentityId);
          }
          formData.append("pageNo", this.pageData.offset);
          formData.append("pageSize", this.pageData.pageNumber);
          // formData.append("status",1);
          this.$server
          .exam("/customer/fingerprint/pageTenantFingerprint", formData)
          .then(data => {
           if (data.code == 200) {
             this.pageData.fgData = data.data.records;
             this.pageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
      },
    tenantPower() {
      var formData = new FormData();
      if (
        this.selectForm.tenantName != "" &&
        this.selectForm.tenantName != null
      ) {
        formData.append("tenantName", this.selectForm.tenantName);
      }
      // formData.append("apartmentId", this.infoData.apartmentId);
      formData.append("pageNo", this.tenantPageData.offset);
      formData.append("pageSize", this.tenantPageData.pageNumber);
      this.$server
        .exam("/customer/tenant/listTenant", formData)
        .then((data) => {
          if (data.code == 200) {
            this.tenantPageData.tenantList = data.data.records;
            this.tenantPageData.total = data.data.total;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
     },

    devicePower(){
          var formData = new FormData();
          formData.append("pageNo", this.devicePageData.offset);
          formData.append("pageSize", this.devicePageData.pageNumber);
          this.$server
          .exam("/customer/gateway/listCardMachine", formData)
          .then(data => {
           if (data.code == 200) {
             this.devicePageData.deviceData = data.data.records;
             this.devicePageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },
     fHandleSizeChange(val) {
       this.pageData.pageNumber = val;
       this.getFgPageList();
     },
     fHandleCurrentChange(val) {
       this.pageData.offset = val;
       this.getFgPageList();
     },
     tenantHandleSizeChange(val) {
      this.tenantPageData.pageNumber = val;
      this.tenantPower();
     },
     tenantHandleCurrentChange(val) {
      this.tenantPageData.offset = val;
      this.tenantPower();
     },
     deviceHandleSizeChange(val) {
      this.devicePageData.pageNumber = val;
      this.devicePower();
     },
     deviceHandleCurrentChange(val) {
      this.devicePageData.offset = val;
      this.devicePower();
     },
  }    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/fingerprintManage/fingerprintList.vue